/* src/components/Blog-Posts.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	claim_component,
	claim_space,
	create_component,
	destroy_component,
	detach,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "../_snowpack/pkg/svelte/internal.js";

import PostLink from "./Post-Link.svelte.js";

function create_fragment(ctx) {
	let postlink0;
	let t0;
	let postlink1;
	let t1;
	let postlink2;
	let t2;
	let postlink3;
	let t3;
	let postlink4;
	let t4;
	let postlink5;
	let t5;
	let postlink6;
	let t6;
	let postlink7;
	let t7;
	let postlink8;
	let t8;
	let postlink9;
	let t9;
	let postlink10;
	let t10;
	let postlink11;
	let t11;
	let postlink12;
	let t12;
	let postlink13;
	let t13;
	let postlink14;
	let t14;
	let postlink15;
	let t15;
	let postlink16;
	let t16;
	let postlink17;
	let current;

	postlink0 = new PostLink({
			props: {
				title: "Test Private Methods with C#",
				slug: "/blog/test-private-methods",
				projects: "",
				tags: "unit test,c-sharp"
			}
		});

	postlink1 = new PostLink({
			props: {
				title: "10Print",
				slug: "/blog/10Print",
				projects: "",
				tags: "p5"
			}
		});

	postlink2 = new PostLink({
			props: {
				title: "Marching Squares Linear Interpolation",
				slug: "/blog/marching-squares-linear-interpolation",
				projects: "",
				tags: "p5"
			}
		});

	postlink3 = new PostLink({
			props: {
				title: "Marching Squares",
				slug: "/blog/marching-squares",
				projects: "",
				tags: "p5"
			}
		});

	postlink4 = new PostLink({
			props: {
				title: "Time Game 4 - WEBGL Demo [V0.02]",
				slug: "/blog/timegame-webgl-002",
				projects: "Time Travel Game",
				tags: "software,unity3d"
			}
		});

	postlink5 = new PostLink({
			props: {
				title: "Time Game 3 - WEBGL Demo [V0.01]",
				slug: "/blog/timegame-3-webgl-demo",
				projects: "Time Travel Game",
				tags: "software,unity3d"
			}
		});

	postlink6 = new PostLink({
			props: {
				title: "Mecanim Animation From Transform",
				slug: "/blog/unity3d-animation-from-transform",
				projects: "",
				tags: "software,unity3d"
			}
		});

	postlink7 = new PostLink({
			props: {
				title: "Time Game 2 - Character Animation",
				slug: "/blog/timegame-2-animations",
				projects: "Time Travel Game",
				tags: "software,unity3d"
			}
		});

	postlink8 = new PostLink({
			props: {
				title: "Time Game 1 - Implementing Time Travel",
				slug: "/blog/timegame-1-timetravel",
				projects: "Time Travel Game",
				tags: "software,unity3d"
			}
		});

	postlink9 = new PostLink({
			props: {
				title: "My Boxstarter Script",
				slug: "/blog/boxstarter-hello-world",
				projects: "",
				tags: "software,automation"
			}
		});

	postlink10 = new PostLink({
			props: {
				title: "3D Printer 5 - Prints",
				slug: "/blog/3d-printing",
				projects: "3D-Printer",
				tags: "hardware"
			}
		});

	postlink11 = new PostLink({
			props: {
				title: "3D Printer 4 - Auto Bed Levelling",
				slug: "/blog/auto-bed-levelling",
				projects: "3D-Printer",
				tags: "hardware"
			}
		});

	postlink12 = new PostLink({
			props: {
				title: "Conky Config",
				slug: "/blog/conky-config",
				projects: "",
				tags: "config,conky"
			}
		});

	postlink13 = new PostLink({
			props: {
				title: "3D Printer 3 - Calibration",
				slug: "/blog/3d-printer-calibration",
				projects: "3D-Printer",
				tags: "hardware,build"
			}
		});

	postlink14 = new PostLink({
			props: {
				title: "A week with Arch ",
				slug: "/blog/a-week-with-arch",
				projects: "",
				tags: "software,setup"
			}
		});

	postlink15 = new PostLink({
			props: {
				title: "3D Printer 2 - Leaking",
				slug: "/blog/3d-printer-wip-leaking",
				projects: "3D-Printer",
				tags: "hardware,build"
			}
		});

	postlink16 = new PostLink({
			props: {
				title: "Arch Linux New Install",
				slug: "/blog/arch-linux-new-install",
				projects: "",
				tags: "setup,software"
			}
		});

	postlink17 = new PostLink({
			props: {
				title: "3D Printer 1 - Build",
				slug: "/blog/3d-printer-build",
				projects: "3D-Printer",
				tags: "hardware,build"
			}
		});

	return {
		c() {
			create_component(postlink0.$$.fragment);
			t0 = space();
			create_component(postlink1.$$.fragment);
			t1 = space();
			create_component(postlink2.$$.fragment);
			t2 = space();
			create_component(postlink3.$$.fragment);
			t3 = space();
			create_component(postlink4.$$.fragment);
			t4 = space();
			create_component(postlink5.$$.fragment);
			t5 = space();
			create_component(postlink6.$$.fragment);
			t6 = space();
			create_component(postlink7.$$.fragment);
			t7 = space();
			create_component(postlink8.$$.fragment);
			t8 = space();
			create_component(postlink9.$$.fragment);
			t9 = space();
			create_component(postlink10.$$.fragment);
			t10 = space();
			create_component(postlink11.$$.fragment);
			t11 = space();
			create_component(postlink12.$$.fragment);
			t12 = space();
			create_component(postlink13.$$.fragment);
			t13 = space();
			create_component(postlink14.$$.fragment);
			t14 = space();
			create_component(postlink15.$$.fragment);
			t15 = space();
			create_component(postlink16.$$.fragment);
			t16 = space();
			create_component(postlink17.$$.fragment);
		},
		l(nodes) {
			claim_component(postlink0.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(postlink1.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(postlink2.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(postlink3.$$.fragment, nodes);
			t3 = claim_space(nodes);
			claim_component(postlink4.$$.fragment, nodes);
			t4 = claim_space(nodes);
			claim_component(postlink5.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(postlink6.$$.fragment, nodes);
			t6 = claim_space(nodes);
			claim_component(postlink7.$$.fragment, nodes);
			t7 = claim_space(nodes);
			claim_component(postlink8.$$.fragment, nodes);
			t8 = claim_space(nodes);
			claim_component(postlink9.$$.fragment, nodes);
			t9 = claim_space(nodes);
			claim_component(postlink10.$$.fragment, nodes);
			t10 = claim_space(nodes);
			claim_component(postlink11.$$.fragment, nodes);
			t11 = claim_space(nodes);
			claim_component(postlink12.$$.fragment, nodes);
			t12 = claim_space(nodes);
			claim_component(postlink13.$$.fragment, nodes);
			t13 = claim_space(nodes);
			claim_component(postlink14.$$.fragment, nodes);
			t14 = claim_space(nodes);
			claim_component(postlink15.$$.fragment, nodes);
			t15 = claim_space(nodes);
			claim_component(postlink16.$$.fragment, nodes);
			t16 = claim_space(nodes);
			claim_component(postlink17.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postlink0, target, anchor);
			insert(target, t0, anchor);
			mount_component(postlink1, target, anchor);
			insert(target, t1, anchor);
			mount_component(postlink2, target, anchor);
			insert(target, t2, anchor);
			mount_component(postlink3, target, anchor);
			insert(target, t3, anchor);
			mount_component(postlink4, target, anchor);
			insert(target, t4, anchor);
			mount_component(postlink5, target, anchor);
			insert(target, t5, anchor);
			mount_component(postlink6, target, anchor);
			insert(target, t6, anchor);
			mount_component(postlink7, target, anchor);
			insert(target, t7, anchor);
			mount_component(postlink8, target, anchor);
			insert(target, t8, anchor);
			mount_component(postlink9, target, anchor);
			insert(target, t9, anchor);
			mount_component(postlink10, target, anchor);
			insert(target, t10, anchor);
			mount_component(postlink11, target, anchor);
			insert(target, t11, anchor);
			mount_component(postlink12, target, anchor);
			insert(target, t12, anchor);
			mount_component(postlink13, target, anchor);
			insert(target, t13, anchor);
			mount_component(postlink14, target, anchor);
			insert(target, t14, anchor);
			mount_component(postlink15, target, anchor);
			insert(target, t15, anchor);
			mount_component(postlink16, target, anchor);
			insert(target, t16, anchor);
			mount_component(postlink17, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(postlink0.$$.fragment, local);
			transition_in(postlink1.$$.fragment, local);
			transition_in(postlink2.$$.fragment, local);
			transition_in(postlink3.$$.fragment, local);
			transition_in(postlink4.$$.fragment, local);
			transition_in(postlink5.$$.fragment, local);
			transition_in(postlink6.$$.fragment, local);
			transition_in(postlink7.$$.fragment, local);
			transition_in(postlink8.$$.fragment, local);
			transition_in(postlink9.$$.fragment, local);
			transition_in(postlink10.$$.fragment, local);
			transition_in(postlink11.$$.fragment, local);
			transition_in(postlink12.$$.fragment, local);
			transition_in(postlink13.$$.fragment, local);
			transition_in(postlink14.$$.fragment, local);
			transition_in(postlink15.$$.fragment, local);
			transition_in(postlink16.$$.fragment, local);
			transition_in(postlink17.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postlink0.$$.fragment, local);
			transition_out(postlink1.$$.fragment, local);
			transition_out(postlink2.$$.fragment, local);
			transition_out(postlink3.$$.fragment, local);
			transition_out(postlink4.$$.fragment, local);
			transition_out(postlink5.$$.fragment, local);
			transition_out(postlink6.$$.fragment, local);
			transition_out(postlink7.$$.fragment, local);
			transition_out(postlink8.$$.fragment, local);
			transition_out(postlink9.$$.fragment, local);
			transition_out(postlink10.$$.fragment, local);
			transition_out(postlink11.$$.fragment, local);
			transition_out(postlink12.$$.fragment, local);
			transition_out(postlink13.$$.fragment, local);
			transition_out(postlink14.$$.fragment, local);
			transition_out(postlink15.$$.fragment, local);
			transition_out(postlink16.$$.fragment, local);
			transition_out(postlink17.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postlink0, detaching);
			if (detaching) detach(t0);
			destroy_component(postlink1, detaching);
			if (detaching) detach(t1);
			destroy_component(postlink2, detaching);
			if (detaching) detach(t2);
			destroy_component(postlink3, detaching);
			if (detaching) detach(t3);
			destroy_component(postlink4, detaching);
			if (detaching) detach(t4);
			destroy_component(postlink5, detaching);
			if (detaching) detach(t5);
			destroy_component(postlink6, detaching);
			if (detaching) detach(t6);
			destroy_component(postlink7, detaching);
			if (detaching) detach(t7);
			destroy_component(postlink8, detaching);
			if (detaching) detach(t8);
			destroy_component(postlink9, detaching);
			if (detaching) detach(t9);
			destroy_component(postlink10, detaching);
			if (detaching) detach(t10);
			destroy_component(postlink11, detaching);
			if (detaching) detach(t11);
			destroy_component(postlink12, detaching);
			if (detaching) detach(t12);
			destroy_component(postlink13, detaching);
			if (detaching) detach(t13);
			destroy_component(postlink14, detaching);
			if (detaching) detach(t14);
			destroy_component(postlink15, detaching);
			if (detaching) detach(t15);
			destroy_component(postlink16, detaching);
			if (detaching) detach(t16);
			destroy_component(postlink17, detaching);
		}
	};
}

class Blog_Posts extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default Blog_Posts;
//# sourceMappingURL=Blog-Posts.svelte.js.map
